var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.colOffsetTitle") } },
    [
      _c("el-input-number", {
        staticStyle: { width: "100%" },
        attrs: { min: 0, max: 24 },
        model: {
          value: _vm.optionModel.offset,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "offset", _vm._n($$v))
          },
          expression: "optionModel.offset",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }